import { BackLink } from "./NewDimension.styles";
import { HeaderConfig } from "layout/ContentLayout/ContentLayout";

export const getHeaderConfig = (id: string): HeaderConfig => ({
  title: id ? "Edit Dimension" : "New Dimension",
  actions: <BackLink to="/frameworks/dimensions">Back to Collection</BackLink>,
});
